const SelectBlackIcon: React.FC = () => {
  return (
    <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.916656L4.16667 5.08332L8.33333 0.916656H0Z" fill="black" />
    </svg>
  );
};
export default SelectBlackIcon;
